export const PRODUCTS_RESULTS_FETCH = 'CS/PRODUCTS_RESULTS_FETCH';
export const PRODUCTS_RESULTS_FETCH_SUCCESS = `${PRODUCTS_RESULTS_FETCH}_SUCCESS`;
export const PRODUCTS_RESULTS_FETCH_ERROR = `${PRODUCTS_RESULTS_FETCH}_ERROR`;
export const STORE_RESULTS_REQUEST_DATA = 'CS/STORE_RESULTS_REQUEST_DATA';

export const PRODUCTS_DETAILS_FETCH = 'CS/PRODUCTS_DETAILS_FETCH';
export const PRODUCTS_DETAILS_FETCH_SUCCESS = `${PRODUCTS_DETAILS_FETCH}_SUCCESS`;
export const PRODUCTS_DETAILS_FETCH_ERROR = `${PRODUCTS_DETAILS_FETCH}_ERROR`;

export const PRODUCTS_APPLY_CLICK = 'CS/PRODUCTS_APPLY_CLICK';
export const PRODUCTS_FETCH_FAILURE = 'CS/PRODUCTS_FETCH_FAILURE';

export const PRODUCT_FILTERS_FETCH = 'CS/PRODUCT_FILTERS_FETCH';
export const PRODUCT_FILTERS_FETCH_ERROR = `${PRODUCT_FILTERS_FETCH}_ERROR`;
export const PRODUCT_FILTERS_FETCH_SUCCESS = `${PRODUCT_FILTERS_FETCH}_SUCCESS`;

export const PRODUCT_SORTING_FETCH = 'PRODUCT_SORTING_FETCH';
export const PRODUCT_SORTING_FETCH_ERROR = `${PRODUCT_SORTING_FETCH}_ERROR`;
export const PRODUCT_SORTING_FETCH_SUCCESS = `${PRODUCT_SORTING_FETCH}_SUCCESS`;

export const PRODUCTS_INELIGIBLE_RESULTS_FETCH = 'CS/PRODUCTS_INELIGIBLE_RESULTS_FETCH';
export const PRODUCTS_INELIGIBLE_RESULTS_FETCH_SUCCESS = `${PRODUCTS_INELIGIBLE_RESULTS_FETCH}_SUCCESS`;
export const PRODUCTS_INELIGIBLE_RESULTS_FETCH_ERROR = `${PRODUCTS_INELIGIBLE_RESULTS_FETCH}_ERROR`;
export const PRODUCTS_INELIGIBLE_RESULTS_FETCH_RESET = `${PRODUCTS_INELIGIBLE_RESULTS_FETCH}_RESET`;
